import styled from "styled-components";

const getBackground = (image) =>
  image ? `url(${image}) no-repeat center center` : "white";

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(8, 57, 80, 0.81);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  @media (max-height: 570px) {
    display: none;
  }
`;
export const ModalContent = styled.div`
  background: ${(props) => getBackground(props.backgroundImage)};
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover; /* troque para cover se quiser que preencha tudo */
  border-radius: 10px;
  width: 820px;
  height: 570px;
  position: relative;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 10000;
  will-change: transform;
  transform: translateZ(0);
  backface-visibility: hidden;
  @media (max-width: 1280px) {
    width: 820px;
    height: 570px;
  }
  @media (max-width: 853px) {
    width: 767px;
    height: 540px;
  }
  @media (max-width: 820px) {
    width: 738px;
    height: 510px;
  }
  @media (max-width: 768px) {
    width: 690px;
    height: 480px;
  }
  @media (max-width: 540px) {
    width: 486px;
    height: 340px;
  }
  @media (max-width: 430px) {
    width: 385px;
    height: 255px;
  }
  @media (max-width: 414px) {
    width: 370px;
    height: 255px;
  }
  @media (max-width: 412px) {
    width: 370px;
    height: 250px;
  }
  @media (max-width: 390px) {
    width: 350px;
    height: 240px;
  }
  @media (max-width: 375px) {
    width: 335px;
    height: 230px;
  }
  @media (max-width: 360px) {
    width: 335px;
    height: 230px;
  }
  @media (max-width: 344px) {
    width: 310px;
    height: 230px;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  gap: 20px;
  height: calc(100% - 160px);
  padding-bottom: 100px;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 21px;
  right: 16px;
  background: none;
  border: none;
  font-size: 52px;
  cursor: pointer;
  color: #ffffff;
  transition: color 0.3s ease;
  z-index: 10001;
  will-change: color;
  transform: translateZ(0);
  @media (max-width: 768px) {
    padding: 5px 5px;
    font-size: 48px;
    top: 10px;
    right: 10px;
  }
  @media (max-width: 540px) {
    padding: 5px 5px;
    font-size: 30px;
    top: 5px;
    right: 5px;
  }
  @media (max-width: 480px) {
    padding: 5px 5px;
    font-size: 20px;
    top: 3px;
    right: 3px;
  }

  &:hover {
    color: #f39200;
  }
`;

export const ContractButton = styled.button`
  background: #f39200;
  color: white;
  padding: 20px 40px; 
  border: none;
  border-radius: 0px;
  font-size: 20px;
  font-weight: 600;
  cursor: pointer;
  display: block;
  margin: 40px auto;
  position: absolute;
  bottom: 35px;
  right: 390px;
  transform: translateX(-50%);
  transition: all 0.2s ease;
  will-change: transform, background-color;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  backface-visibility: hidden;
  line-height: 1.4;

  @media (max-width: 1280px) {
    padding: 15px 30px;
    font-size: 18px;
    bottom: 35px;
    right: 440px;
  }
  @media (max-width: 853px) {
    padding: 15px 30px;
    font-size: 16px;
    bottom: 32px;
    right: 420px;
  }
  @media (max-width: 820px) {
    padding: 15px 30px;
    font-size: 16px;
    bottom: 30px;
    right: 400px;
  }
  @media (max-width: 768px) {
    padding: 15px 30px;
    font-size: 16px;
    bottom: 30px;
    right:340px;
  }
  @media (max-width: 540px) {
    padding: 13px 26px;
    font-size: 14px;
    bottom: -4px;
    right: 185px;
  }
  @media (max-width: 480px) {
    padding: 5px 30px;
    font-size: 8px;
    bottom: 14px;
    right: 125px;
  }
  @media (max-width: 430px) {
    padding: 10px 15px;
    font-size: 10px;
    bottom: -10px;
    right: 160px;
  }
  @media (max-width: 375px) {
    padding: 10px 15px;
    font-size: 10px;
    bottom: -6px;
    right: 140px;
  }
  @media (max-width: 344px) {
    padding: 10px 15px;
    font-size: 8px;
    bottom: -10px;
    right: 140px;
  }
  @media (max-width: 120px) {
    padding: 5px 15px;
    font-size: 10px;
    bottom: 14px;
  }
  &:hover {
    background: #e65c00;
    transform: translateX(-50%) scale(1.05);
  }
`;
